/* Product-specific comparison rail. The purchase flow stays in cosmic-reading.js. */
(() => {
  if (customElements.get('cosmic-comparison')) return;
  class CosmicComparison extends HTMLElement {
    connectedCallback() {
      queueMicrotask(() => { if (this.isConnected && !this.events) this.initialize(); });
    }
    disconnectedCallback() {
      this.events?.abort();
      this.resizeObserver?.disconnect();
      cancelAnimationFrame(this.frame);
      this.events = null;
    }
    initialize() {
      this.track = this.querySelector('[data-comparison-track]');
      if (!this.track) return;
      this.cards = Array.from(this.track.children);
      this.dots = Array.from(this.querySelectorAll('[data-comparison-dot]'));
      this.controls = this.querySelector('[data-comparison-controls]');
      this.prev = this.querySelector('[data-comparison-prev]');
      this.next = this.querySelector('[data-comparison-next]');
      this.count = this.querySelector('[data-comparison-count]');
      this.events = new AbortController();
      const options = { signal: this.events.signal };
      const sync = () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.update());
      };
      this.track.addEventListener('scroll', sync, { ...options, passive: true });
      this.addEventListener('click', event => {
        const dot = event.target.closest('[data-comparison-dot]');
        if (dot) this.show(Number(dot.dataset.comparisonDot));
        if (event.target.closest('[data-comparison-prev]')) this.show(this.index - 1);
        if (event.target.closest('[data-comparison-next]')) this.show(this.index + 1);
      }, options);
      this.track.addEventListener('keydown', event => {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        this.show(event.key === 'Home' ? 0 : event.key === 'End' ? this.cards.length - 1 : this.index + (event.key === 'ArrowRight' ? 1 : -1));
      }, options);
      this.addEventListener('shopify:block:select', event => {
        const card = event.target.closest('.cmp-comparison__card');
        if (card) this.show(this.cards.indexOf(card));
      }, options);
      this.resizeObserver = new ResizeObserver(sync);
      this.resizeObserver.observe(this.track);
      this.update();
      this.dataset.ready = 'true';
    }
    position(index) { return this.cards[index].offsetLeft - this.cards[0].offsetLeft; }
    update() {
      const max = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
      this.controls.hidden = max < 2 || this.cards.length < 2;
      this.index = this.cards.reduce((best, card, index) => Math.abs(Math.min(this.position(index), max) - this.track.scrollLeft) < Math.abs(Math.min(this.position(best), max) - this.track.scrollLeft) ? index : best, 0);
      if (max > 2 && this.track.scrollLeft >= max - 2) this.index = this.cards.length - 1;
      this.prev.disabled = this.track.scrollLeft < 2;
      this.next.disabled = this.track.scrollLeft >= max - 2;
      this.count.textContent = `${this.index + 1} / ${this.cards.length}`;
      this.dots.forEach((dot, index) => index === this.index ? dot.setAttribute('aria-current', 'true') : dot.removeAttribute('aria-current'));
    }
    show(index) {
      const card = Math.max(0, Math.min(index, this.cards.length - 1));
      if (!this.cards[card]) return;
      this.track.scrollTo({ left: this.position(card), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    }
  }
  customElements.define('cosmic-comparison', CosmicComparison);
})();
